var _metadata, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "281.48px",
    height: "178px",
    viewBox: "0 0 281.48 178",
    style: {
      enableBackground: "new 0 0 281.48 178"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 185.937,
    width: 359.97,
    x: -30.987,
    y: -239.437
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8F6FF"
    },
    d: "M0,32c0-11.201,0-16.802,2.18-21.08c1.917-3.763,4.977-6.823,8.74-8.74C15.198,0,20.799,0,32,0 l216.961,0c11.842,0,17.762,0,22.173,2.351c3.876,2.066,6.964,5.351,8.787,9.347c2.075,4.547,1.709,10.456,0.979,22.275l-7.045,114 c-0.653,10.572-0.98,15.857-3.246,19.867c-1.995,3.53-5.016,6.37-8.663,8.144C257.804,178,252.508,178,241.917,178H32 c-11.201,0-16.802,0-21.08-2.18c-3.763-1.917-6.823-4.977-8.74-8.74C0,162.802,0,157.201,0,146L0,32z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0,32c0-11.201,0-16.802,2.18-21.08c1.917-3.763,4.977-6.823,8.74-8.74C15.198,0,20.799,0,32,0l216.961,0 c11.842,0,17.762,0,22.173,2.351c3.876,2.066,6.964,5.351,8.787,9.347c2.075,4.547,1.709,10.456,0.979,22.275l-7.045,114 c-0.653,10.572-0.98,15.857-3.246,19.867c-1.995,3.53-5.016,6.37-8.663,8.144C257.804,178,252.508,178,241.917,178H32 c-11.201,0-16.802,0-21.08-2.18c-3.763-1.917-6.823-4.977-8.74-8.74C0,162.802,0,157.201,0,146L0,32z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FABC26"
    },
    d: "M138.957,18.379c0,0,1.262-1.493,4.637-1.298s5.518,2.792,8.245,2.727 c2.727-0.065,3.895-1.818,3.895-1.818v10.452c0,0-0.779,2.077-4.285,1.883c-3.506-0.195-6.297-3.441-8.634-3.376 c-2.337,0.065-3.858,1.948-3.858,1.948V18.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D5D5F"
    },
    d: "M138.984,40.132L138.984,40.132c-0.369,0-0.668-0.299-0.668-0.668V17.732 c0-0.369,0.299-0.668,0.668-0.668l0,0c0.369,0,0.669,0.299,0.669,0.668v21.731C139.653,39.832,139.354,40.132,138.984,40.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B32B00"
    },
    d: "M250.127,79.654H27.021l17.502-26.28c1.031-1.548,2.767-2.478,4.627-2.478h178.847 c1.86,0,3.596,0.93,4.627,2.478L250.127,79.654z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A8207"
    },
    cx: 265.724,
    cy: 140.233,
    r: 23.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A8207"
    },
    cx: 23.703,
    cy: 138.156,
    r: 23.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5A8207"
    },
    cx: -4.342,
    cy: 129.846,
    r: 23.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: -17.846,
    y: 145.427,
    style: {
      fill: "#8FBA07"
    },
    width: 297.073,
    height: 40.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.013,
    y: 81.026,
    style: {
      fill: "#F3B97E"
    },
    width: 212.937,
    height: 71.671
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M244.824,153.736H32.138c-0.643,0-1.164-0.521-1.164-1.164v-17.407 c0-0.643,0.521-1.164,1.164-1.164h212.686c0.643,0,1.164,0.521,1.164,1.164v17.407 C245.988,153.215,245.467,153.736,244.824,153.736z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.013,
    y: 81.026,
    style: {
      fill: "#CF9863"
    },
    width: 212.937,
    height: 2.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M251.806,81.026H26.617c-0.758,0-1.372-0.614-1.372-1.372v0c0-0.758,0.614-1.372,1.372-1.372 h225.189c0.758,0,1.372,0.614,1.372,1.372v0C253.178,80.412,252.564,81.026,251.806,81.026z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1A860"
    },
    points: "168.934,145.41 109.035,145.41 109.035,67.549 139.212,43.616 168.934,67.549  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.013,
    y: 110.11,
    style: {
      fill: "#CF9863"
    },
    width: 212.964,
    height: 2.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDE8B5"
    },
    d: "M245.988,111.149H32.013c-1.147,0-2.077-0.93-2.077-2.077v0c0-1.147,0.93-2.077,2.077-2.077 h213.976c1.147,0,2.077,0.93,2.077,2.077v0C248.066,110.219,247.135,111.149,245.988,111.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M47.799,129.846H39.22c-0.452,0-0.818-0.366-0.818-0.818v-12.794c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C48.616,129.48,48.25,129.846,47.799,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M47.424,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C48.184,129.094,47.843,129.434,47.424,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M47.424,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C48.184,129.094,47.843,129.434,47.424,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#C4EDE6"
    },
    points: "38.402,123.813 46.625,113.988 37.969,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#C4EDE6"
    },
    points: "38.402,125.198 47.967,113.859 49.612,114.265 38.402,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#C4EDE6"
    },
    points: "41.475,132.426 51.04,121.086 52.685,121.493 41.475,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#C4EDE6"
    },
    points: "37.753,129.007 48.703,116.975 51.646,118.922 40.436,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.287,
    y: 115.571,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.287,
    y: 117.751,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 166.1406 79.122)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M61.687,129.846h-8.579c-0.452,0-0.818-0.366-0.818-0.818v-12.794 c0-0.452,0.366-0.818,0.818-0.818h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C62.505,129.48,62.139,129.846,61.687,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M61.312,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C62.072,129.094,61.732,129.434,61.312,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M61.312,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C62.072,129.094,61.732,129.434,61.312,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#C4EDE6"
    },
    points: "52.291,123.813 60.514,113.988 51.858,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#C4EDE6"
    },
    points: "52.291,125.198 61.855,113.859 63.5,114.265 52.291,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#C4EDE6"
    },
    points: "55.364,132.426 64.928,121.086 66.573,121.493 55.364,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#C4EDE6"
    },
    points: "51.641,129.007 62.591,116.975 65.534,118.922 54.325,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.176,
    y: 115.571,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.176,
    y: 117.751,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 180.0289 65.2336)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M75.575,129.846h-8.579c-0.452,0-0.818-0.366-0.818-0.818v-12.794 c0-0.452,0.366-0.818,0.818-0.818h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C76.393,129.48,76.027,129.846,75.575,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M75.201,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C75.96,129.094,75.62,129.434,75.201,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M75.201,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C75.96,129.094,75.62,129.434,75.201,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#C4EDE6"
    },
    points: "66.179,123.813 74.402,113.988 65.746,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#C4EDE6"
    },
    points: "66.179,125.198 75.744,113.859 77.388,114.265 66.179,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#C4EDE6"
    },
    points: "69.252,132.426 78.817,121.086 80.461,121.493 69.252,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#C4EDE6"
    },
    points: "65.53,129.007 76.48,116.975 79.423,118.922 68.213,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.064,
    y: 115.571,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.064,
    y: 117.751,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 193.9173 51.3453)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M89.464,129.846h-8.579c-0.452,0-0.818-0.366-0.818-0.818v-12.794 c0-0.452,0.366-0.818,0.818-0.818h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C90.281,129.48,89.915,129.846,89.464,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M89.089,129.434H81.26c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C89.849,129.094,89.508,129.434,89.089,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M89.089,129.434H81.26c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C89.849,129.094,89.508,129.434,89.089,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "#C4EDE6"
    },
    points: "80.067,123.813 88.291,113.988 79.635,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "#C4EDE6"
    },
    points: "80.067,125.198 89.632,113.859 91.277,114.265  80.067,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "#C4EDE6"
    },
    points: "83.14,132.426 92.705,121.086 94.35,121.493 83.14,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "#C4EDE6"
    },
    points: "79.418,129.007 90.368,116.975 93.311,118.922  82.102,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.953,
    y: 115.571,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.953,
    y: 117.751,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 207.8057 37.4569)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M103.352,129.846h-8.579c-0.452,0-0.818-0.366-0.818-0.818v-12.794 c0-0.452,0.366-0.818,0.818-0.818h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C104.17,129.48,103.804,129.846,103.352,129.846z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M102.977,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C103.737,129.094,103.397,129.434,102.977,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M102.977,129.434h-7.829c-0.42,0-0.76-0.34-0.76-0.76v-12.086c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C103.737,129.094,103.397,129.434,102.977,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "#C4EDE6"
    },
    points: "93.956,123.813 102.179,113.988 93.523,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "#C4EDE6"
    },
    points: "93.956,125.198 103.521,113.859 105.165,114.265  93.956,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "#C4EDE6"
    },
    points: "97.029,132.426 106.593,121.086 108.238,121.493  97.029,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "#C4EDE6"
    },
    points: "93.307,129.007 104.256,116.975 107.199,118.922  95.99,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98.841,
    y: 115.571,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.841,
    y: 117.751,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 221.694 23.5685)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M47.799,101.658H39.22c-0.452,0-0.818-0.366-0.818-0.818V88.046c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C48.616,101.291,48.25,101.658,47.799,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M47.424,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C48.184,100.906,47.843,101.246,47.424,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M47.424,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C48.184,100.906,47.843,101.246,47.424,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "#C4EDE6"
    },
    points: "38.402,95.625 46.625,85.8 37.969,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "#C4EDE6"
    },
    points: "38.402,97.01 47.967,85.67 49.612,86.077 38.402,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "#C4EDE6"
    },
    points: "41.475,104.237 51.04,92.898 52.685,93.305 41.475,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_14_)",
      fill: "#C4EDE6"
    },
    points: "37.753,100.818 48.703,88.786 51.646,90.734 40.436,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.287,
    y: 87.383,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.287,
    y: 89.563,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 137.9523 50.9337)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M61.687,101.658h-8.579c-0.452,0-0.818-0.366-0.818-0.818V88.046c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C62.505,101.291,62.139,101.658,61.687,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M61.312,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C62.072,100.906,61.732,101.246,61.312,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M61.312,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C62.072,100.906,61.732,101.246,61.312,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "#C4EDE6"
    },
    points: "52.291,95.625 60.514,85.8 51.858,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "#C4EDE6"
    },
    points: "52.291,97.01 61.855,85.67 63.5,86.077 52.291,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "#C4EDE6"
    },
    points: "55.364,104.237 64.928,92.898 66.573,93.305 55.364,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "#C4EDE6"
    },
    points: "51.641,100.818 62.591,88.786 65.534,90.734 54.325,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 57.176,
    y: 87.383,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.176,
    y: 89.563,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 151.8406 37.0453)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M75.575,101.658h-8.579c-0.452,0-0.818-0.366-0.818-0.818V88.046c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C76.393,101.291,76.027,101.658,75.575,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M75.201,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C75.96,100.906,75.62,101.246,75.201,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M75.201,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C75.96,100.906,75.62,101.246,75.201,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#C4EDE6"
    },
    points: "66.179,95.625 74.402,85.8 65.746,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#C4EDE6"
    },
    points: "66.179,97.01 75.744,85.67 77.388,86.077 66.179,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#C4EDE6"
    },
    points: "69.252,104.237 78.817,92.898 80.461,93.305 69.252,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_18_)",
      fill: "#C4EDE6"
    },
    points: "65.53,100.818 76.48,88.786 79.423,90.734 68.213,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.064,
    y: 87.383,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.064,
    y: 89.563,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 165.729 23.157)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M89.464,101.658h-8.579c-0.452,0-0.818-0.366-0.818-0.818V88.046c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C90.281,101.291,89.915,101.658,89.464,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M89.089,101.246H81.26c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C89.849,100.906,89.508,101.246,89.089,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M89.089,101.246H81.26c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C89.849,100.906,89.508,101.246,89.089,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "#C4EDE6"
    },
    points: "80.067,95.625 88.291,85.8 79.635,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "#C4EDE6"
    },
    points: "80.067,97.01 89.632,85.67 91.277,86.077 80.067,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "#C4EDE6"
    },
    points: "83.14,104.237 92.705,92.898 94.35,93.305 83.14,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "#C4EDE6"
    },
    points: "79.418,100.818 90.368,88.786 93.311,90.734 82.102,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.953,
    y: 87.383,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.953,
    y: 89.563,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 179.6174 9.2686)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M103.352,101.658h-8.579c-0.452,0-0.818-0.366-0.818-0.818V88.046 c0-0.452,0.366-0.818,0.818-0.818h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C104.17,101.291,103.804,101.658,103.352,101.658 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M102.977,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C103.737,100.906,103.397,101.246,102.977,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M102.977,101.246h-7.829c-0.42,0-0.76-0.34-0.76-0.76V88.4c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C103.737,100.906,103.397,101.246,102.977,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "#C4EDE6"
    },
    points: "93.956,95.625 102.179,85.8 93.523,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "#C4EDE6"
    },
    points: "93.956,97.01 103.521,85.67 105.165,86.077 93.956,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "#C4EDE6"
    },
    points: "97.029,104.237 106.593,92.898 108.238,93.305  97.029,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "#C4EDE6"
    },
    points: "93.307,100.818 104.256,88.786 107.199,90.734 95.99,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98.841,
    y: 87.383,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.841,
    y: 89.563,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 193.5057 -4.6198)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M122.597,97.533h-8.579c-0.452,0-0.818-0.366-0.818-0.818V83.921c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C123.415,97.167,123.049,97.533,122.597,97.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M122.222,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C122.982,96.781,122.642,97.121,122.222,97.121z"
  }), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M122.222,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C122.982,96.781,122.642,97.121,122.222,97.121z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "#C4EDE6"
    },
    points: "113.201,91.5 121.424,81.675 112.768,81.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "#C4EDE6"
    },
    points: "113.201,92.885 122.766,81.546 124.41,81.952 113.201,95.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "#C4EDE6"
    },
    points: "116.274,100.113 125.839,88.773 127.483,89.18  116.274,102.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "#C4EDE6"
    },
    points: "112.552,96.694 123.502,84.662 126.445,86.609  115.235,99.879  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.086,
    y: 83.258,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.086,
    y: 85.438,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 208.6262 -27.9897)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M136.646,97.533h-8.579c-0.452,0-0.818-0.366-0.818-0.818V83.921c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C137.464,97.167,137.098,97.533,136.646,97.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M136.272,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C137.031,96.781,136.691,97.121,136.272,97.121z"
  }), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M136.272,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C137.031,96.781,136.691,97.121,136.272,97.121z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_26_)",
      fill: "#C4EDE6"
    },
    points: "127.25,91.5 135.473,81.675 126.817,81.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_26_)",
      fill: "#C4EDE6"
    },
    points: "127.25,92.885 136.815,81.546 138.46,81.952 127.25,95.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_26_)",
      fill: "#C4EDE6"
    },
    points: "130.323,100.113 139.888,88.773 141.533,89.18  130.323,102.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_26_)",
      fill: "#C4EDE6"
    },
    points: "126.601,96.694 137.551,84.662 140.494,86.609  129.284,99.879  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132.135,
    y: 83.258,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.135,
    y: 85.438,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 222.6755 -42.039)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M149.944,97.533h-8.579c-0.452,0-0.818-0.366-0.818-0.818V83.921c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C150.762,97.167,150.395,97.533,149.944,97.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M149.569,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C150.329,96.781,149.989,97.121,149.569,97.121z"
  }), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M149.569,97.121h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.275c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76v12.086C150.329,96.781,149.989,97.121,149.569,97.121z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_28_)",
      fill: "#C4EDE6"
    },
    points: "140.548,91.5 148.771,81.675 140.115,81.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_28_)",
      fill: "#C4EDE6"
    },
    points: "140.548,92.885 150.112,81.546 151.757,81.952  140.548,95.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_28_)",
      fill: "#C4EDE6"
    },
    points: "143.62,100.113 153.185,88.773 154.83,89.18 143.62,102.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_28_)",
      fill: "#C4EDE6"
    },
    points: "139.898,96.694 150.848,84.662 153.791,86.609  142.582,99.879  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 145.433,
    y: 83.258,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.433,
    y: 85.438,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 235.9728 -55.3362)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M163.426,97.311h-8.579c-0.452,0-0.818-0.366-0.818-0.818V83.7c0-0.452,0.366-0.818,0.818-0.818 h8.579c0.452,0,0.818,0.366,0.818,0.818v12.794C164.244,96.945,163.877,97.311,163.426,97.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M163.051,96.899h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.053c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76V96.14C163.811,96.559,163.471,96.899,163.051,96.899z"
  }), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M163.051,96.899h-7.829c-0.42,0-0.76-0.34-0.76-0.76V84.053c0-0.42,0.34-0.76,0.76-0.76h7.829 c0.42,0,0.76,0.34,0.76,0.76V96.14C163.811,96.559,163.471,96.899,163.051,96.899z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_30_)",
      fill: "#C4EDE6"
    },
    points: "154.03,91.278 162.253,81.454 153.597,81.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_30_)",
      fill: "#C4EDE6"
    },
    points: "154.03,92.663 163.594,81.324 165.239,81.73 154.03,95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_30_)",
      fill: "#C4EDE6"
    },
    points: "157.102,99.891 166.667,88.551 168.312,88.958  157.102,102.228  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_30_)",
      fill: "#C4EDE6"
    },
    points: "153.38,96.472 164.33,84.44 167.273,86.388 156.064,99.657  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 158.915,
    y: 83.036,
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.915,
    y: 85.217,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 249.233 -69.0401)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M229.854,129.846h8.579c0.452,0,0.818-0.366,0.818-0.818v-12.794c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C229.036,129.48,229.402,129.846,229.854,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M230.229,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C229.469,129.094,229.809,129.434,230.229,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M230.229,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C229.469,129.094,229.809,129.434,230.229,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_32_)",
      fill: "#C4EDE6"
    },
    points: "239.25,123.813 231.027,113.988 239.683,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_32_)",
      fill: "#C4EDE6"
    },
    points: "239.25,125.198 229.686,113.859 228.041,114.265  239.25,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_32_)",
      fill: "#C4EDE6"
    },
    points: "236.177,132.426 226.613,121.086 224.968,121.493  236.177,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_32_)",
      fill: "#C4EDE6"
    },
    points: "239.9,129.007 228.95,116.975 226.007,118.922  237.216,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233.922,
    y: 115.571,
    transform: "matrix(-1 -4.510404e-11 4.510404e-11 -1 468.2866 245.2626)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.922,
    y: 117.751,
    transform: "matrix(-4.920438e-11 1 -1 -4.920438e-11 356.7746 -111.512)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M215.966,129.846h8.579c0.452,0,0.818-0.366,0.818-0.818v-12.794c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C215.148,129.48,215.514,129.846,215.966,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M216.34,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C215.581,129.094,215.921,129.434,216.34,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M216.34,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C215.581,129.094,215.921,129.434,216.34,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_34_)",
      fill: "#C4EDE6"
    },
    points: "225.362,123.813 217.139,113.988 225.795,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_34_)",
      fill: "#C4EDE6"
    },
    points: "225.362,125.198 215.797,113.859 214.152,114.265  225.362,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_34_)",
      fill: "#C4EDE6"
    },
    points: "222.289,132.426 212.724,121.086 211.08,121.493  222.289,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_34_)",
      fill: "#C4EDE6"
    },
    points: "226.011,129.007 215.061,116.975 212.118,118.922  223.328,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 220.033,
    y: 115.571,
    transform: "matrix(-1 -4.510404e-11 4.510404e-11 -1 440.5099 245.2626)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.033,
    y: 117.751,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 342.8862 -97.6237)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M202.077,129.846h8.579c0.452,0,0.818-0.366,0.818-0.818v-12.794c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C201.26,129.48,201.626,129.846,202.077,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M202.452,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C201.692,129.094,202.032,129.434,202.452,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M202.452,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C201.692,129.094,202.032,129.434,202.452,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_36_)",
      fill: "#C4EDE6"
    },
    points: "211.474,123.813 203.25,113.988 211.906,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_36_)",
      fill: "#C4EDE6"
    },
    points: "211.474,125.198 201.909,113.859 200.264,114.265  211.474,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_36_)",
      fill: "#C4EDE6"
    },
    points: "208.401,132.426 198.836,121.086 197.191,121.493  208.401,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_36_)",
      fill: "#C4EDE6"
    },
    points: "212.123,129.007 201.173,116.975 198.23,118.922  209.439,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.145,
    y: 115.571,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 412.7332 245.2626)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.145,
    y: 117.751,
    transform: "matrix(-4.100383e-11 1 -1 -4.100383e-11 328.9979 -83.7353)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M188.189,129.846h8.579c0.452,0,0.818-0.366,0.818-0.818v-12.794c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C187.371,129.48,187.737,129.846,188.189,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M188.564,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C187.804,129.094,188.144,129.434,188.564,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M188.564,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C187.804,129.094,188.144,129.434,188.564,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_38_)",
      fill: "#C4EDE6"
    },
    points: "197.585,123.813 189.362,113.988 198.018,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_38_)",
      fill: "#C4EDE6"
    },
    points: "197.585,125.198 188.02,113.859 186.376,114.265  197.585,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_38_)",
      fill: "#C4EDE6"
    },
    points: "194.512,132.426 184.948,121.086 183.303,121.493  194.512,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_38_)",
      fill: "#C4EDE6"
    },
    points: "198.234,129.007 187.285,116.975 184.342,118.922  195.551,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 192.256,
    y: 115.571,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 384.9565 245.2626)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.256,
    y: 117.751,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 315.1095 -69.8469)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M174.301,129.846h8.579c0.452,0,0.818-0.366,0.818-0.818v-12.794c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C173.483,129.48,173.849,129.846,174.301,129.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M174.675,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C173.916,129.094,174.256,129.434,174.675,129.434z"
  }), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M174.675,129.434h7.829c0.42,0,0.76-0.34,0.76-0.76v-12.086c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C173.916,129.094,174.256,129.434,174.675,129.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_40_)",
      fill: "#C4EDE6"
    },
    points: "183.697,123.813 175.474,113.988 184.13,113.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_40_)",
      fill: "#C4EDE6"
    },
    points: "183.697,125.198 174.132,113.859 172.487,114.265  183.697,127.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_40_)",
      fill: "#C4EDE6"
    },
    points: "180.624,132.426 171.059,121.086 169.415,121.493  180.624,134.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_40_)",
      fill: "#C4EDE6"
    },
    points: "184.346,129.007 173.396,116.975 170.453,118.922  181.663,132.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.368,
    y: 115.571,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 357.1797 245.2626)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.368,
    y: 117.751,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 301.2211 -55.9586)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M229.854,101.658h8.579c0.452,0,0.818-0.366,0.818-0.818V88.046c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C229.036,101.291,229.402,101.658,229.854,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M230.229,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C229.469,100.906,229.809,101.246,230.229,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M230.229,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C229.469,100.906,229.809,101.246,230.229,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_42_)",
      fill: "#C4EDE6"
    },
    points: "239.25,95.625 231.027,85.8 239.683,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_42_)",
      fill: "#C4EDE6"
    },
    points: "239.25,97.01 229.686,85.67 228.041,86.077 239.25,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_42_)",
      fill: "#C4EDE6"
    },
    points: "236.177,104.237 226.613,92.898 224.968,93.305  236.177,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_42_)",
      fill: "#C4EDE6"
    },
    points: "239.9,100.818 228.95,88.786 226.007,90.734 237.216,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233.922,
    y: 87.383,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 468.2866 188.886)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.922,
    y: 89.563,
    transform: "matrix(-4.920438e-11 1 -1 -4.920438e-11 328.5863 -139.7003)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M215.966,101.658h8.579c0.452,0,0.818-0.366,0.818-0.818V88.046c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C215.148,101.291,215.514,101.658,215.966,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M216.34,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C215.581,100.906,215.921,101.246,216.34,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M216.34,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C215.581,100.906,215.921,101.246,216.34,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_44_)",
      fill: "#C4EDE6"
    },
    points: "225.362,95.625 217.139,85.8 225.795,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_44_)",
      fill: "#C4EDE6"
    },
    points: "225.362,97.01 215.797,85.67 214.152,86.077 225.362,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_44_)",
      fill: "#C4EDE6"
    },
    points: "222.289,104.237 212.724,92.898 211.08,93.305  222.289,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_44_)",
      fill: "#C4EDE6"
    },
    points: "226.011,100.818 215.061,88.786 212.118,90.734  223.328,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 220.033,
    y: 87.383,
    transform: "matrix(-1 -4.510404e-11 4.510404e-11 -1 440.5099 188.886)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.033,
    y: 89.563,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 314.6979 -125.812)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M202.077,101.658h8.579c0.452,0,0.818-0.366,0.818-0.818V88.046c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C201.26,101.291,201.626,101.658,202.077,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M202.452,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C201.692,100.906,202.032,101.246,202.452,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M202.452,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C201.692,100.906,202.032,101.246,202.452,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_46_)",
      fill: "#C4EDE6"
    },
    points: "211.474,95.625 203.25,85.8 211.906,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_46_)",
      fill: "#C4EDE6"
    },
    points: "211.474,97.01 201.909,85.67 200.264,86.077 211.474,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_46_)",
      fill: "#C4EDE6"
    },
    points: "208.401,104.237 198.836,92.898 197.191,93.305  208.401,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_46_)",
      fill: "#C4EDE6"
    },
    points: "212.123,100.818 201.173,88.786 198.23,90.734  209.439,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 206.145,
    y: 87.383,
    transform: "matrix(-1 -4.510404e-11 4.510404e-11 -1 412.7332 188.886)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.145,
    y: 89.563,
    transform: "matrix(-4.100383e-11 1 -1 -4.100383e-11 300.8096 -111.9236)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M188.189,101.658h8.579c0.452,0,0.818-0.366,0.818-0.818V88.046c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C187.371,101.291,187.737,101.658,188.189,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M188.564,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C187.804,100.906,188.144,101.246,188.564,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M188.564,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C187.804,100.906,188.144,101.246,188.564,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_48_)",
      fill: "#C4EDE6"
    },
    points: "197.585,95.625 189.362,85.8 198.018,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_48_)",
      fill: "#C4EDE6"
    },
    points: "197.585,97.01 188.02,85.67 186.376,86.077 197.585,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_48_)",
      fill: "#C4EDE6"
    },
    points: "194.512,104.237 184.948,92.898 183.303,93.305  194.512,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_48_)",
      fill: "#C4EDE6"
    },
    points: "198.234,100.818 187.285,88.786 184.342,90.734  195.551,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 192.256,
    y: 87.383,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 384.9565 188.886)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.256,
    y: 89.563,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 286.9212 -98.0352)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M174.301,101.658h8.579c0.452,0,0.818-0.366,0.818-0.818V88.046c0-0.452-0.366-0.818-0.818-0.818 h-8.579c-0.452,0-0.818,0.366-0.818,0.818v12.794C173.483,101.291,173.849,101.658,174.301,101.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M174.675,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C173.916,100.906,174.256,101.246,174.675,101.246z"
  }), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M174.675,101.246h7.829c0.42,0,0.76-0.34,0.76-0.76V88.4c0-0.42-0.34-0.76-0.76-0.76h-7.829 c-0.42,0-0.76,0.34-0.76,0.76v12.086C173.916,100.906,174.256,101.246,174.675,101.246z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_50_)",
      fill: "#C4EDE6"
    },
    points: "183.697,95.625 175.474,85.8 184.13,85.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_50_)",
      fill: "#C4EDE6"
    },
    points: "183.697,97.01 174.132,85.67 172.487,86.077 183.697,99.347  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_50_)",
      fill: "#C4EDE6"
    },
    points: "180.624,104.237 171.059,92.898 169.415,93.305  180.624,106.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_50_)",
      fill: "#C4EDE6"
    },
    points: "184.346,100.818 173.396,88.786 170.453,90.734  181.663,104.004  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 178.368,
    y: 87.383,
    transform: "matrix(-1 -4.100377e-11 4.100377e-11 -1 357.1797 188.886)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 14.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.368,
    y: 89.563,
    transform: "matrix(-4.510366e-11 1 -1 -4.510366e-11 273.0328 -84.1469)",
    style: {
      fill: "#664723"
    },
    width: 0.444,
    height: 9.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.525,
    y: 54.976,
    style: {
      fill: "#C25533"
    },
    width: 6.817,
    height: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.089,
    y: 64.044,
    style: {
      fill: "#C25533"
    },
    width: 5.044,
    height: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.558,
    y: 73.176,
    style: {
      fill: "#C25533"
    },
    width: 6.881,
    height: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.442,
    y: 67.549,
    style: {
      fill: "#C25533"
    },
    width: 6.881,
    height: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.263,
    y: 59.196,
    style: {
      fill: "#C25533"
    },
    width: 5.561,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.165,
    y: 59.423,
    style: {
      fill: "#C25533"
    },
    width: 9.589,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.302,
    y: 74.387,
    style: {
      fill: "#C25533"
    },
    width: 6.745,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.754,
    y: 54.895,
    style: {
      fill: "#C25533"
    },
    width: 7.953,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.707,
    y: 64.417,
    style: {
      fill: "#C25533"
    },
    width: 4.199,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.101,
    y: 54.36,
    style: {
      fill: "#C25533"
    },
    width: 4.199,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.064,
    y: 59.38,
    style: {
      fill: "#C25533"
    },
    width: 4.199,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.156,
    y: 70.849,
    style: {
      fill: "#C25533"
    },
    width: 7.022,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.365,
    y: 72.104,
    style: {
      fill: "#C25533"
    },
    width: 4.199,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.064,
    y: 66.045,
    style: {
      fill: "#C25533"
    },
    width: 4.199,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.483,
    y: 75.177,
    style: {
      fill: "#C25533"
    },
    width: 5.479,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.991,
    y: 72.64,
    style: {
      fill: "#C25533"
    },
    width: 10.747,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.335,
    y: 62.816,
    style: {
      fill: "#C25533"
    },
    width: 7.109,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.51,
    y: 56.913,
    style: {
      fill: "#C25533"
    },
    width: 5.654,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.093,
    y: 54.576,
    style: {
      fill: "#C25533"
    },
    width: 10.371,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.28,
    y: 68.02,
    style: {
      fill: "#C25533"
    },
    width: 7.433,
    height: 1.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.035,
    y: 78.023,
    style: {
      fill: "#D4904F"
    },
    width: 59.899,
    height: 1.073
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDE8B5"
    },
    points: "102.759,67.549 109.035,67.549 139.212,43.616 168.934,67.549 175.156,67.549  139.212,38.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4904F"
    },
    points: "109.035,67.549 109.035,69.091 138.838,45.693 168.934,69.091 168.934,67.549  139.212,43.616  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#664723"
    },
    cx: 139.212,
    cy: 63.516,
    r: 7.263
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 139.212,
    cy: 63.516,
    r: 6.474
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M139.441,63.791l-0.007,0.005c-0.13,0.1-0.316,0.077-0.416-0.053l-3.208-4.146 c-0.1-0.13-0.077-0.316,0.053-0.416l0.007-0.005c0.13-0.1,0.316-0.077,0.416,0.053l3.208,4.146 C139.594,63.504,139.571,63.69,139.441,63.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M139.506,63.39L139.506,63.39c0.094,0.121,0.071,0.295-0.05,0.389l-2.59,2.004 c-0.121,0.094-0.295,0.071-0.389-0.05v0c-0.094-0.121-0.071-0.295,0.05-0.389l2.59-2.004 C139.238,63.247,139.412,63.269,139.506,63.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.319,
    y: 114.378,
    style: {
      fill: "#FDE8B5"
    },
    width: 5.498,
    height: 27.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.64,
    y: 114.378,
    style: {
      fill: "#E8D09F"
    },
    width: 2.177,
    height: 27.69
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353537"
    },
    d: "M148.528,144.631h-19.151v-24.69c0-1.351,1.095-2.446,2.446-2.446h14.259 c1.351,0,2.446,1.095,2.446,2.446V144.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#352B37"
    },
    d: "M146.082,117.494h-14.259c-1.351,0-2.446,1.095-2.446,2.446v1.883c0-1.351,1.095-2.446,2.446-2.446 h14.259c1.351,0,2.446,1.095,2.446,2.446v-1.883C148.528,118.589,147.433,117.494,146.082,117.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M129.376,144.631H117.95v-24.993c0-1.363,1.105-2.468,2.468-2.468h6.49 c1.363,0,2.468,1.105,2.468,2.468V144.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M159.953,144.631h-11.426v-24.993c0-1.363,1.105-2.468,2.468-2.468h6.49 c1.363,0,2.468,1.105,2.468,2.468V144.631z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.567,
    y: 114.378,
    style: {
      fill: "#FDE8B5"
    },
    width: 5.498,
    height: 27.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.887,
    y: 114.378,
    style: {
      fill: "#E8D09F"
    },
    width: 2.177,
    height: 27.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.035,
    y: 111.781,
    style: {
      fill: "#D4904F"
    },
    width: 59.899,
    height: 2.484
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M116.649,114.378h-5.163c-0.959,0-1.736-0.777-1.736-1.736v-0.861h8.634v0.861 C118.385,113.601,117.608,114.378,116.649,114.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M166.897,114.378h-5.163c-0.959,0-1.736-0.777-1.736-1.736v-0.861h8.634v0.861 C168.633,113.601,167.856,114.378,166.897,114.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M166.989,142.034h-5.347c-0.908,0-1.644,0.736-1.644,1.644v0.953h8.634v-0.953 C168.633,142.77,167.897,142.034,166.989,142.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C66040"
    },
    d: "M116.741,142.034h-5.347c-0.908,0-1.644,0.736-1.644,1.644v0.953h8.634v-0.953 C118.385,142.77,117.649,142.034,116.741,142.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M128.078,125.999h-9.124v-6.183c0-0.953,0.772-1.725,1.725-1.725h5.674 c0.953,0,1.725,0.772,1.725,1.725V125.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1E5"
    },
    d: "M158.819,125.999h-9.124v-6.183c0-0.953,0.772-1.725,1.725-1.725h5.674 c0.953,0,1.725,0.772,1.725,1.725V125.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAEFF1"
    },
    d: "M122.278,118.09l-3.324,5.117v2.792h4.562l3.992-7.457c0,0-0.491-0.451-0.902-0.451 C124.854,118.09,122.278,118.09,122.278,118.09z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAEFF1"
    },
    points: "124.334,125.999 128.078,119.528 128.078,121.476 125.568,125.999  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAEFF1"
    },
    d: "M153.019,118.09l-3.324,5.117v2.792h4.562l3.992-7.457c0,0-0.491-0.451-0.902-0.451 C155.594,118.09,153.019,118.09,153.019,118.09z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAEFF1"
    },
    points: "155.075,125.999 158.819,119.528 158.819,121.476 156.308,125.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#353537"
    },
    points: "105.356,81.009 90.281,153.736 109.035,153.736 109.035,81.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#353537"
    },
    points: "172.613,81.009 187.687,153.736 168.934,153.736 168.934,81.009  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.226,
    y: 149.218,
    style: {
      fill: "#FDE8B5"
    },
    width: 67.257,
    height: 4.588
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.823,
    y: 144.631,
    style: {
      fill: "#FDE8B5"
    },
    width: 62.063,
    height: 4.588
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDE8B5"
    },
    d: "M169.994,78.023h-62.312c-1.088,0-1.969-0.882-1.969-1.969v0c0-1.088,0.882-1.969,1.969-1.969 h62.312c1.088,0,1.969,0.882,1.969,1.969v0C171.964,77.141,171.082,78.023,169.994,78.023z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.217,
    y: 103.039,
    style: {
      fill: "#FDE8B5"
    },
    width: 63.362,
    height: 8.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.217,
    y: 103.039,
    style: {
      fill: "#FEF3D8"
    },
    width: 63.362,
    height: 1.878
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.823,
    y: 147.8,
    style: {
      fill: "#DEC696"
    },
    width: 62.063,
    height: 1.418
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.226,
    y: 152.388,
    style: {
      fill: "#DEC696"
    },
    width: 67.257,
    height: 1.418
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -13.977,
    y: 123.074,
    style: {
      fill: "#664723"
    },
    width: 4.934,
    height: 34.278
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M-25.922,136.359v-20.116h-3.895v22.022l0,0c0,2.151,1.744,3.895,3.895,3.895h16.879v-3.895 h-14.973C-25.069,138.265-25.922,137.412-25.922,136.359z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: -4.631,
    cy: 118.137,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: -14.4,
    cy: 94.246,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: -31.83,
    cy: 116.243,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: 2.899,
    cy: 105.153,
    r: 9.636
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.211,
    y: 123.074,
    style: {
      fill: "#664723"
    },
    width: 4.934,
    height: 34.278
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#664723"
    },
    d: "M274.266,136.359v-20.116h-3.895v22.022l0,0c0,2.151,1.744,3.895,3.895,3.895h16.879v-3.895 h-14.973C275.119,138.265,274.266,137.412,274.266,136.359z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: 295.557,
    cy: 118.137,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: 285.788,
    cy: 94.246,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: 268.358,
    cy: 116.243,
    r: 15.417
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8FBA07"
    },
    cx: 303.088,
    cy: 105.153,
    r: 9.636
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.ecbc03186a2430c8b6e68eee9e49d770.svg";
export { ForwardRef as ReactComponent };